export function page_specials() {
	
	( ( $ ) => {

		if ( $( 'body.page-specials' ).length <= 0 ) {
			return;
		}

        $( document ).on( 'click', '.facetwp-facet-specials_categories .facetwp-radio *', () => {
            FWP.refresh();
            const selected = FWP.facets['specials_categories'];
            // console.log(123, selected, FWP.facets);
        })

	} )( window.jQuery );
}